export enum TemplateFilterType {
    TYPE = 'type',
    CONSENT_REQUIRED = 'consentRequired',
    SUBMISSION_STATUS = 'submissionStatus',
    STATUS = 'status',
    ARCHIVE_STATUS = 'archiveStatus',
    CATERGORY = 'category'
}